import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { track } from '@/api/posthog'
import { useAuthStore } from '@/stores/auth'

export function setupAppLifecycle(): void {
  if (!Capacitor.isNativePlatform()) return

  App.addListener('appStateChange', ({ isActive }) => {
    if (isActive) {
      track('app_resumed')
      // Refresh /me when the app returns to the foreground so changes made
      // while it was backgrounded show up — e.g. being added to a new
      // workspace. fetchMe() keeps the session on transient errors and only
      // clears on a real 401, so this is safe to fire-and-forget.
      const auth = useAuthStore()
      if (auth.token) auth.fetchMe()
    } else {
      track('app_backgrounded')
    }
  })

  App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) {
      window.history.back()
    } else {
      App.exitApp()
    }
  })
}
